import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-triangle-down-medium, dropdown, caret"} maskId="square-filled-radius-0-stroke-1-IconChevronTriangleDownMedium"><path d="M12 16.7744L5.42188 9H18.5781L12 16.7744Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTriangleDownMedium;
